(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alvarak-catalogue-soon"] && !Shopify.designMode) return;
  try {
    
(() => {
  const validCategories = new Set(['party', 'baking', 'gift', 'wellness', 'school', 'shopper', 'greeting', 'napkins', 'halloween']);

  const initCatalogue = (scope) => {
    const root = scope || document;
    const sections = root.querySelectorAll('.alv-catalogues');

    sections.forEach((section) => {
      const currentUrl = new URL(window.location.href);
      const selectedCategory = currentUrl.searchParams.get('catalogue_category');
      const intro = section.querySelector('.alv-catalogues__intro');
      const categoryNav = section.querySelector('.alv-catalogues__categories');
      const groups = section.querySelector('.alv-catalogues__groups');
      const modal = section.querySelector('[data-alv-media-modal]');
      if (modal && !modal.dataset.bound) {
        const modalTitle = modal.querySelector('[data-alv-media-title]');
        const modalContent = modal.querySelector('[data-alv-media-content]');
        const closeButtons = modal.querySelectorAll('[data-alv-media-close]');
        const closeModal = () => {
          modal._alvPdfSession = (modal._alvPdfSession || 0) + 1;
          if (modal._alvPageFlip) {
            try { modal._alvPageFlip.destroy(); } catch (error) {}
            modal._alvPageFlip = null;
          }
          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
          modalContent.innerHTML = '';
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        };

        const loadPdfJs = () => {
          if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
          if (window.__alvPdfJsPromise) return window.__alvPdfJsPromise;
          window.__alvPdfJsPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
            script.async = true;
            script.onload = () => {
              if (!window.pdfjsLib) {
                reject(new Error('PDF.js did not initialize'));
                return;
              }
              window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
              resolve(window.pdfjsLib);
            };
            script.onerror = () => reject(new Error('Could not load PDF viewer'));
            document.head.appendChild(script);
          });
          return window.__alvPdfJsPromise;
        };

        const loadPageFlip = () => {
          if (window.St && window.St.PageFlip) return Promise.resolve(window.St.PageFlip);
          if (window.__alvPageFlipPromise) return window.__alvPageFlipPromise;
          window.__alvPageFlipPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/page-flip@2.0.7/dist/js/page-flip.browser.min.js';
            script.async = true;
            script.onload = () => {
              if (!window.St || !window.St.PageFlip) {
                reject(new Error('PageFlip did not initialize'));
                return;
              }
              resolve(window.St.PageFlip);
            };
            script.onerror = () => reject(new Error('Could not load page-flip engine'));
            document.head.appendChild(script);
          });
          return window.__alvPageFlipPromise;
        };

        const openFastPdf = async (link) => {
          const source = link.dataset.alvSource;
          const title = link.dataset.alvTitle || 'Catalogue';
          const cover = link.dataset.alvCover || '';
          if (!source) return;

          const session = (modal._alvPdfSession || 0) + 1;
          modal._alvPdfSession = session;
          if (modal._alvPageFlip) {
            try { modal._alvPageFlip.destroy(); } catch (error) {}
            modal._alvPageFlip = null;
          }

          modalTitle.textContent = title;
          modalContent.innerHTML = '';

          const viewer = document.createElement('div');
          viewer.className = 'alv-fast-pdf';
          viewer.innerHTML = `
            <div class="alv-book-stage">
              <button class="alv-book-nav alv-book-nav--prev" type="button" aria-label="Previous pages">‹</button>
              <div class="alv-book-shell">
                <div class="alv-book-cover-preview"></div>
                <div class="alv-book"></div>
              </div>
              <button class="alv-book-nav alv-book-nav--next" type="button" aria-label="Next pages">›</button>
              <div class="alv-book-status">Loading catalogue…</div>
              <div class="alv-book-toolbar">
                <button type="button" data-book-prev aria-label="Previous pages">‹</button>
                <span class="alv-book-counter">Cover</span>
                <button type="button" data-book-next aria-label="Next pages">›</button>
                <button type="button" data-book-fullscreen aria-label="Full screen">⛶</button>
              </div>
            </div>`;
          modalContent.appendChild(viewer);

          const book = viewer.querySelector('.alv-book');
          const preview = viewer.querySelector('.alv-book-cover-preview');
          const status = viewer.querySelector('.alv-book-status');
          const counter = viewer.querySelector('.alv-book-counter');
          const prevButtons = [viewer.querySelector('.alv-book-nav--prev'), viewer.querySelector('[data-book-prev]')];
          const nextButtons = [viewer.querySelector('.alv-book-nav--next'), viewer.querySelector('[data-book-next]')];
          const fullscreenButton = viewer.querySelector('[data-book-fullscreen]');

          if (cover) {
            const image = document.createElement('img');
            image.src = cover;
            image.alt = title;
            preview.appendChild(image);
          }

          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
          document.body.style.overflow = 'hidden';

          let pdf = null;
          let pageFlip = null;
          let pageElements = [];
          const renderJobs = new Map();

          const updateCounter = (index = 0) => {
            if (!pdf) {
              counter.textContent = 'Cover';
              prevButtons.forEach((button) => { if (button) button.disabled = true; });
              nextButtons.forEach((button) => { if (button) button.disabled = true; });
              return;
            }
            const page = Math.min(pdf.numPages, index + 1);
            counter.textContent = page + ' / ' + pdf.numPages;
            prevButtons.forEach((button) => { if (button) button.disabled = index <= 0; });
            nextButtons.forEach((button) => { if (button) button.disabled = index >= pdf.numPages - 1; });
          };

          const renderPage = async (pageNumber, baseWidth) => {
            if (!pdf || pageNumber < 1 || pageNumber > pdf.numPages) return;
            const target = pageElements[pageNumber - 1];
            if (!target || target.dataset.rendered === 'true') return;
            if (renderJobs.has(pageNumber)) return renderJobs.get(pageNumber);

            const job = (async () => {
              const page = await pdf.getPage(pageNumber);
              if (modal._alvPdfSession !== session) return;
              const unitViewport = page.getViewport({ scale: 1 });
              const pixelRatio = Math.min(window.devicePixelRatio || 1, 1.6);
              const renderScale = (baseWidth * pixelRatio) / unitViewport.width;
              const viewport = page.getViewport({ scale: renderScale });
              const canvas = document.createElement('canvas');
              canvas.width = Math.ceil(viewport.width);
              canvas.height = Math.ceil(viewport.height);
              const context = canvas.getContext('2d', { alpha: false });
              await page.render({ canvasContext: context, viewport }).promise;
              if (modal._alvPdfSession !== session) return;
              target.innerHTML = '';
              target.appendChild(canvas);
              target.dataset.rendered = 'true';
            })().finally(() => renderJobs.delete(pageNumber));

            renderJobs.set(pageNumber, job);
            return job;
          };

          const renderAround = (index, baseWidth) => {
            const pageNumber = index + 1;
            for (let n = Math.max(1, pageNumber - 3); n <= Math.min(pdf.numPages, pageNumber + 6); n += 1) {
              renderPage(n, baseWidth).catch(() => {});
            }
            pageElements.forEach((element, i) => {
              if (Math.abs(i - index) > 10 && element.dataset.rendered === 'true') {
                element.dataset.rendered = 'false';
                element.innerHTML = '<div class="alv-book-page__placeholder"></div>';
              }
            });
          };

          updateCounter();

          try {
            const [pdfjsLib, PageFlip] = await Promise.all([loadPdfJs(), loadPageFlip()]);
            if (modal._alvPdfSession !== session) return;

            const loadingTask = pdfjsLib.getDocument({
              url: source,
              rangeChunkSize: 131072,
              disableAutoFetch: true,
              disableStream: false
            });
            pdf = await loadingTask.promise;
            if (modal._alvPdfSession !== session) return;

            status.textContent = 'Building the book…';
            const firstPdfPage = await pdf.getPage(1);
            const firstViewport = firstPdfPage.getViewport({ scale: 1 });
            const pageWidth = 600;
            const pageHeight = Math.max(420, Math.round(pageWidth * firstViewport.height / firstViewport.width));

            const fragment = document.createDocumentFragment();
            pageElements = [];
            for (let i = 1; i <= pdf.numPages; i += 1) {
              const pageElement = document.createElement('div');
              pageElement.className = 'alv-book-page';
              pageElement.dataset.pageNumber = String(i);
              pageElement.dataset.rendered = 'false';
              pageElement.innerHTML = '<div class="alv-book-page__placeholder"></div>';
              fragment.appendChild(pageElement);
              pageElements.push(pageElement);
            }
            book.appendChild(fragment);

            await Promise.all([renderPage(1, pageWidth), renderPage(2, pageWidth)]);
            if (modal._alvPdfSession !== session) return;

            pageFlip = new PageFlip(book, {
              width: pageWidth,
              height: pageHeight,
              size: 'stretch',
              minWidth: 280,
              maxWidth: pageWidth,
              minHeight: 360,
              maxHeight: pageHeight,
              drawShadow: true,
              flippingTime: 650,
              usePortrait: true,
              startZIndex: 0,
              autoSize: true,
              maxShadowOpacity: 0.5,
              showCover: true,
              mobileScrollSupport: false,
              swipeDistance: 28,
              useMouseEvents: true,
              disableFlipByClick: false
            });
            modal._alvPageFlip = pageFlip;

            pageFlip.on('flip', (event) => {
              const index = Number(event.data) || 0;
              updateCounter(index);
              renderAround(index, pageWidth);
            });
            pageFlip.on('changeOrientation', () => {
              const index = pageFlip.getCurrentPageIndex();
              renderAround(index, pageWidth);
            });
            pageFlip.loadFromHTML(pageElements);

            book.classList.add('is-ready');
            preview.classList.add('is-hidden');
            status.hidden = true;
            updateCounter(0);
            renderAround(0, pageWidth);

            const goPrev = () => {
              if (!pageFlip) return;
              const index = pageFlip.getCurrentPageIndex();
              renderAround(Math.max(0, index - 2), pageWidth);
              pageFlip.flipPrev('bottom');
            };
            const goNext = () => {
              if (!pageFlip) return;
              const index = pageFlip.getCurrentPageIndex();
              renderAround(Math.min(pdf.numPages - 1, index + 2), pageWidth);
              pageFlip.flipNext('bottom');
            };

            prevButtons.forEach((button) => button && button.addEventListener('click', goPrev));
            nextButtons.forEach((button) => button && button.addEventListener('click', goNext));
            fullscreenButton.addEventListener('click', () => {
              if (viewer.requestFullscreen) viewer.requestFullscreen().catch(() => {});
            });

            const keyHandler = (event) => {
              if (modal.hidden || modal._alvPdfSession !== session) {
                document.removeEventListener('keydown', keyHandler);
                return;
              }
              if (event.key === 'ArrowRight') goNext();
              if (event.key === 'ArrowLeft') goPrev();
            };
            document.addEventListener('keydown', keyHandler);
          } catch (error) {
            if (modal._alvPdfSession !== session) return;
            book.classList.add('is-ready');
            preview.classList.add('is-hidden');
            book.innerHTML = '<div class="alv-book-error"><strong>Catalogue could not be opened.</strong><p>Please close this window and try again.</p></div>';
            status.hidden = true;
          }
        };

        section.addEventListener('click', (event) => {
          const fastPdfLink = event.target.closest('[data-alv-fast-pdf]');
          if (fastPdfLink && section.contains(fastPdfLink)) {
            event.preventDefault();
            openFastPdf(fastPdfLink);
            return;
          }
          const viewerLink = event.target.closest('[data-alv-media-viewer]');
          if (viewerLink && section.contains(viewerLink)) {
            event.preventDefault();
            openModal(viewerLink);
          }
        });
        closeButtons.forEach((button) => button.addEventListener('click', closeModal));
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !modal.hidden) closeModal();
        });
        modal.dataset.bound = 'true';
      }


      section.querySelectorAll('[data-catalogue-open]').forEach((link) => {
        const linkUrl = new URL(window.location.href);
        linkUrl.searchParams.set('catalogue_category', link.dataset.catalogueOpen);
        linkUrl.hash = '';
        link.href = linkUrl.toString();
      });

      const previewThemeId = currentUrl.searchParams.get('preview_theme_id');
      if (previewThemeId) {
        section.querySelectorAll('[data-catalogue-page]').forEach((link) => {
          const pageUrl = new URL(link.getAttribute('href'), window.location.origin);
          pageUrl.searchParams.set('preview_theme_id', previewThemeId);
          link.href = pageUrl.toString();
        });
      }

      if (!validCategories.has(selectedCategory)) {
        section.classList.remove('alv-catalogues--category-view');
        if (intro) intro.hidden = false;
        if (categoryNav) categoryNav.hidden = false;
        if (groups) groups.hidden = true;
        return;
      }

      section.classList.add('alv-catalogues--category-view');
      if (intro) intro.hidden = true;
      if (categoryNav) categoryNav.hidden = true;
      if (groups) groups.hidden = false;

      section.querySelectorAll('[data-catalogue-category]').forEach((group) => {
        group.hidden = group.dataset.catalogueCategory !== selectedCategory;
      });

      const footerBackLink = document.querySelector('.back-to-top');
      if (footerBackLink) {
        const mainCatalogueUrl = new URL(window.location.href);
        mainCatalogueUrl.searchParams.delete('catalogue_category');
        mainCatalogueUrl.hash = '';
        footerBackLink.href = mainCatalogueUrl.toString();
        footerBackLink.textContent = section.dataset.backLabel || footerBackLink.textContent;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCatalogue(document), { once: true });
  } else {
    initCatalogue(document);
  }

  document.addEventListener('shopify:section:load', (event) => initCatalogue(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
